export default __webpack_public_path__ + "static/logo-wealth-mobile-eb054285e518e55417ea8a5753a0c708.svg";